/* Albemore before/after comparison
   Progressive enhancement for the results slider section. Without this file each card
   shows an honest side-by-side Before/After pair (the CSS fallback). With it, each card
   collapses to one frame with a draggable divider: the "before" pane is clipped by the
   --arc-pos custom property, and a native range input carries keyboard and screen-reader
   support for free, so this script only mirrors pointer drags onto that input and writes
   --arc-pos back. Vanilla, no dependencies, multi-instance and Theme-Editor safe. */
(function () {
  'use strict';

  function clamp(n, lo, hi) {
    return Math.min(hi, Math.max(lo, n));
  }

  function Card(card) {
    this.card = card;
    this.frame = card.querySelector('[data-arc-frame]');
    this.control = card.querySelector('[data-arc-control]');
    this.input = card.querySelector('[data-arc-input]');
    if (!this.frame || !this.control || !this.input) return;
    this.dragging = false;
    this.init();
  }

  Card.prototype.setPos = function (pct) {
    var v = clamp(Math.round(pct), 0, 100);
    this.card.style.setProperty('--arc-pos', v + '%');
    if (String(this.input.value) !== String(v)) this.input.value = v;
  };

  Card.prototype.posFromEvent = function (clientX) {
    var rect = this.frame.getBoundingClientRect();
    if (!rect.width) return null;
    return ((clientX - rect.left) / rect.width) * 100;
  };

  Card.prototype.init = function () {
    var self = this;

    // The control (range + divider) is hidden by default so the no-JS fallback is a plain
    // pair. Reveal it and switch the card into the clip-path layout.
    this.control.hidden = false;
    this.card.classList.add('is-ready');
    this.setPos(parseFloat(this.input.value) || 50);

    // Keyboard, Home/End, and AT come from the native input.
    this.input.addEventListener('input', function () {
      self.setPos(parseFloat(self.input.value) || 0);
    });

    // Pointer drag anywhere on the frame.
    var onMove = function (e) {
      if (!self.dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      var pct = self.posFromEvent(x);
      if (pct === null) return;
      self.setPos(pct);
      if (e.cancelable) e.preventDefault();
    };

    var start = function (e) {
      self.dragging = true;
      self.card.classList.add('is-dragging');
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      var pct = self.posFromEvent(x);
      if (pct !== null) self.setPos(pct);
    };

    var end = function () {
      if (!self.dragging) return;
      self.dragging = false;
      self.card.classList.remove('is-dragging');
    };

    this.frame.addEventListener('mousedown', start);
    this.frame.addEventListener('touchstart', start, { passive: true });
    window.addEventListener('mousemove', onMove, { passive: false });
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('mouseup', end);
    window.addEventListener('touchend', end);
    window.addEventListener('touchcancel', end);

    // Keep the focus ring usable: focusing the range should not scroll-jump the divider.
    this.input.addEventListener('focus', function () {
      self.card.classList.add('is-focused');
    });
    this.input.addEventListener('blur', function () {
      self.card.classList.remove('is-focused');
    });
  };

  function boot(scope) {
    var cards = (scope || document).querySelectorAll('[data-arc-card]');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.__arcReady) return;
      card.__arcReady = true;
      new Card(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
